import React from "react";
import Typography from "@material-ui/core/Typography";
import { labMachineAnalysisUseStyle } from "../../../utils/styles";

export const Title = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const classes = labMachineAnalysisUseStyle();

  return (
    <Typography
      variant="h5"
      color="primary"
      style={{
        fontWeight: "bold",
        padding: 10,
        backgroundColor: "#f8f8f8",
      }}
      className={classes.titleSpacing}>
      {children}
    </Typography>
  );
};

export const SubTitle = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const classes = labMachineAnalysisUseStyle();

  return (
    <Typography variant="h6" color="primary" className={classes.filters}>
      {children}
    </Typography>
  );
};
